/*
Тип действия с записью таблицы
*/

export enum TableEditType {
  Add = 'add',
  Edit = 'edit',
}
